import { writable, type Writable } from "svelte/store";
import type { user_question_permissions_record, users_record } from "$lib/types/supabase";

export const users_list: Writable<Array<user_question_permissions_record & { users: users_record }>> = writable([]);
export const user_avatars: Writable<Record<string, { url: string | undefined; img: Blob | undefined }>> = writable({});
